import { AppConfig } from '@scansource-brazil/zeus-core-ui/types';
import { URL } from '~/types/CommonTypes';
import { defineStore } from 'pinia';

export const useAppStore = defineStore(
  'MY_SCAN_SOURCE_APP_STORE',
  () => {
    const SCANSOURCE_SITE_URL = '//www.scansource.com.br';
    const baseURL = ref<string | null>(null);
    const clientId = ref<string | null>(null);
    const accountsURL = ref<string | null>(null);
    const apiKey = ref<string | null>(null);
    const featureFlagURL = ref<string | null>(null);

    function setAppConfig(config: AppConfig & { featureFlagURL: URL }) {
      baseURL.value = config.baseURL;
      clientId.value = config.clientId;
      accountsURL.value = config.accountsURL ?? null;
      apiKey.value = config.apiKey ?? null;
      featureFlagURL.value = config.featureFlagURL;
    }

    return {
      SCANSOURCE_SITE_URL,
      baseURL,
      clientId,
      accountsURL,
      apiKey,
      featureFlagURL,
      setAppConfig,
    };
  },
  { persist: true },
);
